var map = {
	"./aia.svg": 89796,
	"./ant.svg": 6868,
	"./aus.svg": 22042,
	"./bah.svg": 7494,
	"./ban.svg": 75224,
	"./bar.svg": 22844,
	"./ber.svg": 54752,
	"./biz.svg": 37004,
	"./bot.svg": 21264,
	"./bru.svg": 49118,
	"./can.svg": 15237,
	"./cay.svg": 54634,
	"./cmr.svg": 97437,
	"./cok.svg": 92366,
	"./cyp.svg": 47707,
	"./dma.svg": 50697,
	"./eng.svg": 2547,
	"./fij.svg": 93032,
	"./flk.svg": 23570,
	"./gab.svg": 51245,
	"./gam.svg": 60122,
	"./ggy.svg": 34024,
	"./gha.svg": 76917,
	"./gib.svg": 7621,
	"./grn.svg": 72652,
	"./guy.svg": 3154,
	"./ind.svg": 64428,
	"./iom.svg": 38358,
	"./ivb.svg": 14970,
	"./jam.svg": 42963,
	"./jey.svg": 20947,
	"./ken.svg": 97497,
	"./kir.svg": 32177,
	"./lca.svg": 81163,
	"./les.svg": 38411,
	"./manifest.json": 21537,
	"./mas.svg": 55090,
	"./maw.svg": 42750,
	"./mdv.svg": 95588,
	"./mlt.svg": 45502,
	"./moz.svg": 46269,
	"./mri.svg": 84289,
	"./msr.svg": 54937,
	"./nam.svg": 54631,
	"./nfk.svg": 15336,
	"./ngr.svg": 75666,
	"./nir.svg": 48424,
	"./niu.svg": 50823,
	"./nru.svg": 1834,
	"./nzl.svg": 87019,
	"./pak.svg": 7123,
	"./png.svg": 10194,
	"./rsa.svg": 3537,
	"./rwa.svg": 71397,
	"./sam.svg": 63158,
	"./sco.svg": 96894,
	"./sey.svg": 30542,
	"./sgp.svg": 57597,
	"./shn.svg": 51006,
	"./skn.svg": 82695,
	"./sle.svg": 83377,
	"./sol.svg": 50273,
	"./sri.svg": 73031,
	"./svg-country.svg": 43524,
	"./swz.svg": 74999,
	"./tan.svg": 99202,
	"./tca.svg": 23587,
	"./tga.svg": 7391,
	"./tog.svg": 42137,
	"./tto.svg": 25764,
	"./tuv.svg": 51041,
	"./uga.svg": 95174,
	"./van.svg": 39292,
	"./wal.svg": 51995,
	"./zam.svg": 64195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76531;